import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { LocaleProvider } from '../core/Context/LocaleProvider';
import Navigation from '../Navigation';
import LinkWithImage from '../core/LinkWithImage';
import { getLocalizedLink } from '../../utils/helpers';

import { StyledHeader } from './styles';

const Header = ({ homeLink, mainNav }) => {
  const locale = useContext(LocaleProvider);
  return (
    <StyledHeader>
      {homeLink.imageSharp && (
        <LinkWithImage
          linkURL={getLocalizedLink(homeLink.linkURL, locale)}
          imageSrc={homeLink.imageSrc}
          imageSharp={homeLink.imageSharp}
          altText={homeLink.altText}
          className="home-link"
        />
      )}
      <Navigation links={mainNav} className="primary" />
    </StyledHeader>
  );
};

Header.propTypes = {
  homeLink: PropTypes.shape({
    linkURL: PropTypes.string,
    imageSrc: PropTypes.string,
    imageSharp: PropTypes.object,
    altText: PropTypes.string,
  }).isRequired,
  mainNav: PropTypes.array.isRequired,
};

export default Header;
